import { createApi } from '@reduxjs/toolkit/query/react';

import { PopupApiResponse, PopupDetail } from '@/types/Popup';

import { generateBaseQuseryWithReAuth } from '../baseQueryReauth';

export const popupApi = createApi({
  reducerPath: 'popupApi',
  keepUnusedDataFor: 300,
  baseQuery: generateBaseQuseryWithReAuth({ useStrapiServer: true, basePath: '', cache: 'no-store' }),
  tagTypes: ['PopUp'],
  endpoints: builder => ({
    getPopup: builder.query<PopupDetail, void>({
      query: () => ({
        url: `/pawtree/pop-up`,
        next: { tags: ['PopUp'] },
      }),
      providesTags: ['PopUp'],
      transformResponse(baseQueryReturnValue: PopupApiResponse, meta, arg) {
        return baseQueryReturnValue?.results?.[0];
      },
    }),
  }),
});

export const { useGetPopupQuery } = popupApi;
